import { useId } from 'react';

export interface NoAutocompleteAttrs {
    name: string;
    autoComplete: 'new-password';
}

const NO_AUTOCOMPLETE_PREFIX = 'no-autocomplete';

export const withSemanticEventName = <T extends { name: string }, TResult>(
    target: T,
    semanticName: string | undefined,
    callback: () => TResult,
): TResult => {
    if (!semanticName || target.name === semanticName) {
        return callback();
    }

    const domName = target.name;
    target.name = semanticName;
    try {
        // Form libraries read event.target.name synchronously. Restore immediately so
        // the focused DOM node does not keep a browser-recognizable semantic name.
        return callback();
    } finally {
        target.name = domName;
    }
};

export const useNoAutocomplete = (prefix?: string): NoAutocompleteAttrs => {
    const id = useId();
    // useId() may contain colons; strip non-alphanumeric chars but keep the full value
    // to preserve React's uniqueness guarantee across the component tree.
    const suffix = id.replace(/[^A-Za-z0-9]/g, '');
    return { name: `${prefix ?? NO_AUTOCOMPLETE_PREFIX}-${suffix}`, autoComplete: 'new-password' };
};
